const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

const escapeHtml = (text) => text.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);

// The output goes into dangerouslySetInnerHTML: the input is escaped first so only the tags added below are markup.
export const convertMarkdownToHtml = (text) => {
  let html = escapeHtml(String(text ?? ''));

  // Convert tables first
  const tableRegex = /(\|.+\|\n)+/g;
  html = html.replace(tableRegex, (match) => {
    const lines = match.trim().split('\n');
    if (lines.length < 2) return match;

    // Parse header
    const headers = lines[0].split('|').filter(cell => cell.trim()).map(cell => cell.trim());

    // Parse body rows
    const rows = lines.slice(2).map(line =>
      line.split('|').filter(cell => cell.trim()).map(cell => cell.trim())
    );

    // Build HTML table with improved styling (no scroll, responsive)
    let table = '<div class="my-4 rounded-lg border border-gray-300 shadow-sm">';
    table += '<table class="w-full table-fixed divide-y divide-gray-300">';
    table += '<thead class="bg-gradient-to-r from-purple-50 to-purple-100">';
    table += '<tr>';
    headers.forEach(header => {
      table += `<th class="px-3 py-3 text-left text-xs font-bold text-purple-900 uppercase tracking-wider border-r border-gray-300 last:border-r-0 break-words">${header}</th>`;
    });
    table += '</tr>';
    table += '</thead>';
    table += '<tbody class="bg-white divide-y divide-gray-200">';
    rows.forEach((row, idx) => {
      const bgClass = idx % 2 === 0 ? 'bg-white' : 'bg-gray-50';
      table += `<tr class="${bgClass} hover:bg-purple-50 transition-colors">`;
      row.forEach(cell => {
        table += `<td class="px-3 py-3 text-xs text-gray-800 border-r border-gray-200 last:border-r-0 break-words">${cell}</td>`;
      });
      table += '</tr>';
    });
    table += '</tbody>';
    table += '</table>';
    table += '</div>';

    return table;
  });

  // Convert headers (must be done before bold/italic to avoid conflicts)
  html = html.replace(/^#### (.+)$/gm, '<h4 class="text-base font-bold text-gray-900 mt-3 mb-1">$1</h4>');
  html = html.replace(/^### (.+)$/gm, '<h3 class="text-lg font-bold text-gray-900 mt-3 mb-1">$1</h3>');
  html = html.replace(/^## (.+)$/gm, '<h2 class="text-xl font-bold text-gray-900 mt-3 mb-2">$1</h2>');
  html = html.replace(/^# (.+)$/gm, '<h1 class="text-2xl font-bold text-gray-900 mt-4 mb-2">$1</h1>');

  // Convert bold text **text** or __text__
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong class="font-bold text-gray-900">$1</strong>');
  html = html.replace(/__(.+?)__/g, '<strong class="font-bold text-gray-900">$1</strong>');

  // Convert italic text *text* or _text_
  html = html.replace(/\*(.+?)\*/g, '<em class="italic">$1</em>');
  html = html.replace(/_(.+?)_/g, '<em class="italic">$1</em>');

  // Convert inline code `code`
  html = html.replace(/`(.+?)`/g, '<code class="bg-gray-100 text-purple-700 px-1.5 py-0.5 rounded text-sm font-mono">$1</code>');

  // Convert unordered lists - item
  html = html.replace(/^- (.+)$/gm, '<li class="ml-4">• $1</li>');
  html = html.replace(/(<li class="ml-4">[\s\S]+?<\/li>)/g, '<ul class="my-1 space-y-0.5">$1</ul>');

  // Convert ordered lists 1. item
  html = html.replace(/^\d+\. (.+)$/gm, '<li class="ml-4 list-decimal">$1</li>');

  // Convert line breaks - but reduce excessive spacing
  html = html.replace(/\n\n+/g, '<br/>');
  html = html.replace(/\n/g, ' ');

  return html;
};
